module.exports = __webpack_public_path__ + "static/media/enter-meeting.e624a23b.svg";